const defaultSeo = {
  title: "Osiyatech - IT Services, Web & App Development",
  description:
    "Osiyatech is a trusted IT company offering web development, app development, AI solutions, API integration, QA testing, and cloud services for businesses worldwide.",
  path: "/",
  keywords:
    "IT company, web development, app development, AI solutions, software development, Osiyatech",
};

const seoByPath = {
  "/": {
    title: "Osiyatech - Service-Based IT Company | Managed IT Services",
    description:
      "Start your digital journey with Osiyatech. We build user-friendly mobile apps, websites, AI solutions, and custom software tailored to your business goals.",
    path: "/",
    keywords:
      "Osiyatech, IT services, web development, app development, AI, cloud solutions",
  },
  "/aboutus": {
    title: "About Us - Trusted IT Service Provider Since 2012",
    description:
      "Learn about Osiyatech, a trusted IT service provider since 2012 offering software development, web design, mobile apps, API integration, and custom IT solutions.",
    path: "/aboutus",
    keywords: "about Osiyatech, IT company India, software development company",
  },
  "/services": {
    title: "App Development Services",
    description:
      "Custom mobile and web app development services from Osiyatech. From requirement analysis to launch, we build scalable applications for your business.",
    path: "/services",
    keywords: "app development, mobile app development, custom software",
  },
  "/all_services": {
    title: "All Services - Software & IT Solutions",
    description:
      "Explore all Osiyatech services including app development, web development, AI & machine learning, API integration, website optimization, and QA testing.",
    path: "/All_Services",
    keywords: "IT services, software services, web development, AI services",
  },
  "/portfolio": {
    title: "Portfolio - Our Work & Projects",
    description:
      "View Osiyatech portfolio showcasing web development, mobile apps, e-commerce, and enterprise software projects delivered for clients worldwide.",
    path: "/portfolio",
    keywords: "Osiyatech portfolio, web projects, app projects, case studies",
  },
  "/career": {
    title: "Careers - Join Our Team",
    description:
      "Explore career opportunities at Osiyatech. Join our team of developers, designers, and IT professionals building innovative digital solutions.",
    path: "/career",
    keywords: "Osiyatech careers, IT jobs, developer jobs, software jobs",
  },
  "/contactus": {
    title: "Contact Us - Get In Touch",
    description:
      "Contact Osiyatech for web development, app development, AI solutions, and IT services. Reach our team via email or contact form today.",
    path: "/contactus",
    keywords: "contact Osiyatech, IT company contact, software development inquiry",
  },
  "/webdevelopment": {
    title: "Web Development Services",
    description:
      "Professional web development services from Osiyatech. We build modern, responsive, SEO-friendly websites customized for your business needs.",
    path: "/webdevelopment",
    keywords: "web development, website design, responsive websites, React development",
  },
  "/payment": {
    title: "API Integration Services",
    description:
      "Osiyatech provides secure API integration services to connect your systems, automate workflows, and improve business efficiency.",
    path: "/payment",
    keywords: "API integration, payment gateway, third-party API, system integration",
  },
  "/websiteoptimization": {
    title: "Website Optimization Services",
    description:
      "Improve your website speed, SEO, and user experience with Osiyatech website optimization services including performance and technical SEO.",
    path: "/websiteoptimization",
    keywords: "website optimization, page speed, SEO, web performance",
  },
  "/itsolution": {
    title: "IT Solution Services",
    description:
      "Comprehensive IT solutions from Osiyatech including IT assessments, strategy, infrastructure, security, and managed IT services for your business.",
    path: "/itsolution",
    keywords: "IT solutions, managed IT services, IT consulting, business technology",
  },
  "/qatesting": {
    title: "QA Testing Services",
    description:
      "Osiyatech QA testing services ensure your software is reliable, secure, and bug-free with web, mobile, performance, security, and automation testing.",
    path: "/qatesting",
    keywords: "QA testing, software testing, automation testing, quality assurance",
  },
  "/aimachinelearning": {
    title: "AI & Machine Learning Services",
    description:
      "Custom AI and machine learning solutions from Osiyatech including AI chatbots, NLP, computer vision, predictive analytics, and generative AI integration.",
    path: "/aimachinelearning",
    keywords:
      "AI development, machine learning, AI chatbot, NLP, generative AI, custom AI solutions",
  },
  "/dataaanalytics": {
    title: "Data & Analytics Services",
    description:
      "Osiyatech data and analytics services including data engineering, business intelligence, data migration, governance, and real-time analytics solutions.",
    path: "/DataAanalytics",
    keywords: "data analytics, data engineering, business intelligence, data migration",
  },
  "/dataaanalytics1": {
    title: "Data Analytics Expertise & Projects",
    description:
      "Explore Osiyatech data analytics expertise including Dynamics 365 integration, Excel automation, financial data workflows, and reporting solutions.",
    path: "/DataAanalytics1",
    keywords: "data analytics projects, Excel automation, Dynamics 365, financial reporting",
  },
};

export const getSeoForPath = (pathname) => {
  const key = pathname.toLowerCase();
  return seoByPath[key] || defaultSeo;
};

export const SITE_URL = "https://www.osiyatech.com";
